<button class="floatingFilterDs__cont floatingFilterDs__cont--{{size}}" aria-label="floatingFilterDs" (click)="clickEvent.emit()">
  <div class="floatingFilterDs__tag floatingFilterDs__tag--{{type}} floatingFilterDs__tag--{{type}}-{{size}} floatingFilterDs__tag--{{type}}-{{state}}">
    <app-ds-image
      [size]="imageSize"
      [src]="image"
      [objectFit]="'contain'"
      [alt]="label">
    </app-ds-image>
  </div>
  <div class="floatingFilterDs__text">
    <app-ds-typography
      [size]="fontSize.XXXS"
      [color]="fontColor.Primary"
      [text]="label"
      [ellipsis]="true">
    </app-ds-typography>
  </div>
</button>